/**
 * The Command Center's loading placeholder: three board columns beside the
 * detail rail, matching the populated surface's grid so the swap does not
 * reflow.
 *
 * This lived in the project workspace page until that page was removed. It is
 * the global Command Center's skeleton now and nothing else's, so it sits next
 * to the surface it stands in for.
 */

import { Skeleton } from "../ui/skeleton";

export function CommandCenterTaskSurfaceSkeleton() {
  return (
    <div className="grid min-h-0 flex-1 grid-cols-1 gap-0 overflow-hidden lg:grid-cols-[minmax(0,1fr)_360px]">
      <div className="min-w-0 overflow-hidden p-4 sm:p-5">
        <div className="grid gap-3 md:grid-cols-3">
          {["col-1", "col-2", "col-3"].map((column) => (
            <div key={column} className="space-y-3">
              <Skeleton className="h-5 w-24 rounded-full" />
              {["item-1", "item-2", "item-3"].map((item) => (
                <Skeleton key={item} className="h-20 w-full rounded-md" />
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="hidden border-l border-border/50 p-4 lg:block">
        <Skeleton className="h-5 w-36 rounded-full" />
        <Skeleton className="mt-5 h-4 w-full rounded-full" />
        <Skeleton className="mt-3 h-4 w-10/12 rounded-full" />
        <Skeleton className="mt-6 h-24 w-full rounded-md" />
      </div>
    </div>
  );
}
